// resources/js/app.js

import { createApp } from 'vue';
import router from './router';
import App from './App.vue';
import store from './store'; // Ensure this path is correct
import IdleTimeout from './plugins/IdleTimeout';

const app = createApp(App);

// Use the Vuex store and router
app.use(store);
app.use(router);
app.use(IdleTimeout, { timeout: 300000, store }); // 5 minutes timeout

// Fetch user data from localStorage and set it in the Vuex store
const token = localStorage.getItem('token');
const user = localStorage.getItem('user');
if (token) {
  store.commit('setToken', token);
}
if (user) {
  store.commit('setUser', JSON.parse(user));
}

// Navigation guard for authentication checks
router.beforeEach((to, from, next) => {
  // Check if the route requires authentication and the user is not logged in
  if (to.matched.some(record => record.meta.requiresAuth) && !store.state.token) {
    next({ name: 'Login' }); // Redirect to login if not logged in
  } else {
    next(); // Continue to the next route
  }
});

// Mount the app
app.mount('#app');
